import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const SettingsContext = createContext(null);

const DEFAULT_SETTINGS = {
    company_name: "Proxiq Tech AI",
    company_email: "proxiqtechai@gmail.com",
    company_phone: "9638813094",
    company_address: "",
    gst_number: "",
    upi_id: "proxiqtech@upi",
    website: "",
    theme: "blue",
    founder_name: "Aynul Memon",
    footer_signature: "Designed & Managed by Proxiq Tech AI",
};

export function SettingsProvider({ children }) {
    const { user } = useAuth();
    const [settings, setSettings] = useState(DEFAULT_SETTINGS);
    const [loaded, setLoaded] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/settings");
            setSettings({ ...DEFAULT_SETTINGS, ...data });
        } catch {
            // not authed yet — keep defaults
        } finally {
            setLoaded(true);
        }
    }, []);

    // Load when user logs in
    useEffect(() => {
        if (user) refresh();
    }, [user, refresh]);

    // Apply theme to <html data-theme>
    useEffect(() => {
        const t = settings.theme || "blue";
        document.documentElement.setAttribute("data-theme", t);
    }, [settings.theme]);

    const update = async (patch) => {
        const { data } = await api.put("/settings", patch);
        setSettings({ ...DEFAULT_SETTINGS, ...data });
        return data;
    };

    return (
        <SettingsContext.Provider value={{ settings, loaded, refresh, update }}>
            {children}
        </SettingsContext.Provider>
    );
}

export const useSettings = () => useContext(SettingsContext) || { settings: DEFAULT_SETTINGS, loaded: false };
